import icons from '@iconify-json/mdi/icons.json';
import metadata from '@iconify-json/mdi/metadata.json';

const categoryMap = {};

for (const [category, names] of Object.entries(metadata.categories)) {
    for (const name of names) {
        categoryMap[name] = category;
    }
}

function tokenize(str) {
    return str.toLowerCase().split(/[\s-/]+/).filter(Boolean);
}

export const iconList = Object.keys(icons.icons).map((name) => {
  const category = categoryMap[name] || '';
  const label = name.replace(/-/g, ' ');

  const tokens = [...tokenize(name), ...tokenize(category), ...tokenize(label)];

  return {
    name: 'mdi-' + name,
    label,
    category,
    tokens
  }
})